import { memo } from 'react';

import { BoardTemplateModalTemplatePreview } from '~/components/Modals/BoardTemplateModal/BoardTemplateModalTemplatePreview';
import { BoardTemplateModalTemplateSelection } from '~/components/Modals/BoardTemplateModal/BoardTemplateModalTemplateSelection';
import { type BoardTemplate } from '~/components/Modals/BoardTemplateModal/types';

export type BoardTemplateModalTemplatesTabProps = {
  selectedTemplateId: string | null;
  onSelectTemplate: (templateId: string) => void;
  templates: Array<{ id: string; title: string; description: string; boards: BoardTemplate[] }>;
};

export const BoardTemplateModalTemplatesTab = memo(
  ({ selectedTemplateId, onSelectTemplate, templates }: BoardTemplateModalTemplatesTabProps) => {
    return (
      <div className="flex min-h-[400px] gap-6 py-4">
        <BoardTemplateModalTemplateSelection
          selectedTemplateId={selectedTemplateId}
          onSelectTemplate={onSelectTemplate}
          templates={templates}
        />
        <BoardTemplateModalTemplatePreview selectedTemplateId={selectedTemplateId} templates={templates} />
      </div>
    );
  },
);

BoardTemplateModalTemplatesTab.displayName = 'BoardTemplateModalTemplatesTab';
